import config from "../config"
const baseUrl = config.base_url + "expert/"
export default {
    list: {
        url: baseUrl + "species-bind/current",
        type: "get",
    },
    add: {
        url: baseUrl + "species-bind/add",
        type: "post",
    },
} 
